export async function getDatabaseVersion(indexedDB, namespace, version, log) {
    function openAndGetVersion(resolve, reject) {
        let currentVersion;
        let database;
        const request = indexedDB.open([namespace, 'collections'].join('_'), version);
        request.onupgradeneeded = async (event) => {
            currentVersion = event.oldVersion;
            const transaction = request.transaction;
            database = request.result;
            transaction.abort();
        };
        request.onsuccess = (event) => {
            resolve([request.result.version, request.result]);
        };
        request.onblocked = (event) => {
            // retry if blocked
            log === null || log === void 0 ? void 0 : log('Database blocked, waiting...');
            // setTimeout(() => {
            // 	openAndGetVersion(resolve, reject);
            // }, 200);
        };
        request.onerror = (event) => {
            // FIXME: this fails if the code is older than the local database
            resolve([currentVersion, database]);
        };
    }
    const [currentVersion, db] = await new Promise(openAndGetVersion);
    await closeDatabase(db);
    return currentVersion;
}
export async function closeDatabase(db) {
    db.close();
    // FIXME: this isn't right!!!!
    await new Promise((resolve) => resolve());
}
/**
 * Upgrades the database to the given version, using the given upgrader function.
 */
export async function upgradeDatabase(indexedDb, namespace, version, upgrader, log) {
    function openAndUpgrade(resolve, reject) {
        const request = indexedDb.open([namespace, 'collections'].join('_'), version);
        let wasUpgraded = false;
        request.onupgradeneeded = (event) => {
            const transaction = request.transaction;
            upgrader(transaction, request.result, event);
            wasUpgraded = true;
        };
        request.onsuccess = (event) => {
            request.result.close();
            if (wasUpgraded) {
                resolve();
            }
            else {
                reject(new Error('Database was not upgraded when a version change was expected'));
            }
        };
        request.onerror = (event) => {
            reject(request.error || new Error('Unknown error'));
        };
        request.onblocked = (event) => {
            log === null || log === void 0 ? void 0 : log('Database upgrade blocked, waiting...');
            // setTimeout(() => {
            // 	openAndUpgrade(resolve, reject);
            // }, 200);
        };
    }
    return new Promise(openAndUpgrade);
}
export async function acquireLock(namespace, procedure) {
    if (typeof navigator !== 'undefined' && navigator.locks) {
        await navigator.locks.request(`verdant_migration_${namespace}`, procedure);
    }
    else {
        // TODO: is there a fallback?
        await procedure();
    }
}
export async function openDatabase(indexedDb, namespace, version, log) {
    log === null || log === void 0 ? void 0 : log('debug', 'Opening database', namespace, 'at version', version);
    const db = await new Promise((resolve, reject) => {
        const request = indexedDb.open([namespace, 'collections'].join('_'), version);
        request.onupgradeneeded = async (event) => {
            const transaction = request.transaction;
            transaction.abort();
            log === null || log === void 0 ? void 0 : log('error', 'Database upgrade needed, but not expected', 'Expected', version, 'Got', request.result.version);
            reject(request.error ||
                new Error(`Migration error: database version changed unexpectedly when reading current data. Expected ${version}, got ${request.result.version}`));
        };
        request.onsuccess = (event) => {
            resolve(request.result);
        };
        request.onblocked = (event) => {
            reject(new Error('Migration error: database blocked'));
        };
        request.onerror = (event) => {
            reject(new Error('Migration error: database error'));
        };
    });
    db.addEventListener('versionchange', (event) => {
        db.close();
    });
    return db;
}
//# sourceMappingURL=db.js.map